import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c34cc66"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]

import { ref, onMounted, onUnmounted, computed, watch } from "vue";
import { adService } from "@/app/services/AdService";
import { useCustomRouter } from "@/utils/router";
import { DisplaySlot } from "@/types/ad/DisplaySlot";
import { openInNewWindow } from "@/utils/browserUtil";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Ad',
  props: {
  adSlot: {
    type: String,
    required: true
  }
},
  setup(__props) {

const props = __props;



const { pushIgnoreError } = useCustomRouter();
const ad = ref<DisplaySlot | null>(null);
const modalVisible = ref(false);

const containerId = computed(() => `ad-container-${ad.value?.slotName}`);

const handleAdClickEvent = (event: Event) => {
  if (ad.value) {
    adService.handleAdClickEvent(event, ad.value.id, ad.value.slotId);
  }
};

onMounted(async () => {
  await displaySlot();
});

onUnmounted(() => {
  window.removeEventListener("click", handleAdClickEvent);
});

watch(
  () => props.adSlot,
  async () => {
    await displaySlot();
  }
);

async function displaySlot() {
  const displaySlot = await adService.displaySlot(props.adSlot);
  if (displaySlot) {
    ad.value = displaySlot;

    // モーダル広告スロットの場合はモーダル表示フラグをたてる
    if (displaySlot.slotIsModal) {
      modalVisible.value = true;

      // 重複して登録されないようにイベントリスナーを削除してから登録
      window.removeEventListener("click", handleAdClickEvent);
      window.addEventListener("click", handleAdClickEvent);
    }

    // 表示イベントを送信（await しない）
    adService.registerEvent(displaySlot.id, "view_slot", displaySlot.slotId);
  }
}

function navigateToLink() {
  const adValue = ad.value!;
  const linkType = adValue.linkType;

  // クリックイベントを送信（await しない）
  // do_nothing でもイベントを送信する
  adService.registerEvent(
    adValue.id,
    "click_slot",
    adValue.slotId,
    JSON.stringify({
      linkType: linkType,
      redirectUrl: adValue.redirectUrl
    })
  );

  if (adValue.linkType === "internal") {
    if (adValue.redirectUrl) {
      pushIgnoreError(adValue.redirectUrl);
    }
  } else if (linkType === "external") {
    if (adValue.redirectUrl && adValue.redirectUrl.startsWith("https://")) {
      openInNewWindow(adValue.redirectUrl);
    }
  } else if (linkType === "detail_page") {
    pushIgnoreError({ name: "AdsDetail", params: { adId: adValue.id } });
  }
}

function onClickCloseModal() {
  modalVisible.value = false;
  adService.registerClickEvent(ad.value!.id, "close-modal", ad.value!.slotId);
}

return (_ctx: any,_cache: any) => {
  const _component_BModal = _resolveComponent("BModal")!

  return (ad.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: containerId.value
      }, [
        (!ad.value.slotIsModal)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              innerHTML: ad.value.html,
              onClick: navigateToLink
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createBlock(_component_BModal, {
              key: 1,
              modelValue: modalVisible.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modalVisible).value = $event)),
              "hide-header": "",
              "hide-footer": "",
              id: "ad-modal",
              "body-class": "ad-modal-body",
              centered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(FeatherIcon, {
                  icon: "x-square",
                  size: "32",
                  class: "close-icon",
                  onClick: onClickCloseModal
                }),
                _createTextVNode(),
                _createElementVNode("div", {
                  innerHTML: ad.value.html
                }, null, 8, _hoisted_3)
              ], undefined, true),
              _: 1
            }, 8, ["modelValue"]))
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})